import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";
import { Button, Stack } from "@mui/material";
import RecordCounter from "@entrilia/shared/components/filters/RecordCounter";
import SearchField from "@entrilia/shared/components/inputs/SearchField";
import MultiSelectFilter from "@entrilia/shared/components/MultiSelectFilter";
import CompaniesIcon from "@entrilia/shared/icons/CompaniesIcon";
import type { Fund } from "../../../../api/types/commonApiTypes";
import type { ContactFilterOption, ContactsFilterState } from "./contactsListHelper";
import PortalRoleSelect from "./PortalRoleSelect";

interface Props {
  fundOptions: Fund[];
  contactOptions: ContactFilterOption[];
  filters: ContactsFilterState;
  onFiltersChange: (patch: Partial<ContactsFilterState>) => void;
  recordsCount: number;
  totalRecordsCount: number;
}

const ContactsFilters = ({
  fundOptions,
  contactOptions,
  filters,
  onFiltersChange,
  recordsCount,
  totalRecordsCount,
}: Props) => {
  const isAnyFilterApplied = filters.fundIds.length > 0 || filters.contactIds.length > 0 || filters.role !== "";

  return (
    <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
      <Stack direction="row" spacing={1.5} sx={{ alignItems: "center" }}>
        <MultiSelectFilter
          sortOptions
          placeholder="Funds"
          options={fundOptions}
          getOptionValue={(fund) => fund.id}
          getOptionLabel={(fund) => fund.name}
          selectedValues={filters.fundIds}
          onChange={(fundIds) => onFiltersChange({ fundIds })}
          StartIcon={CompaniesIcon}
        />
        <MultiSelectFilter
          sortOptions
          placeholder="Contacts"
          options={contactOptions}
          getOptionValue={(contact) => contact.contactId}
          getOptionLabel={(contact) => contact.name}
          getOptionDescription={(contact) => contact.email ?? ""}
          selectedValues={filters.contactIds}
          onChange={(contactIds) => onFiltersChange({ contactIds })}
          StartIcon={PersonOutlineRoundedIcon}
        />
        <PortalRoleSelect
          role={filters.role}
          onChange={(role) => onFiltersChange({ role })}
          roleOptions={["None", "Member", "Admin"]}
        />
        {isAnyFilterApplied && (
          <Button variant="text" onClick={() => onFiltersChange({ fundIds: [], contactIds: [], role: "" })}>
            Clear all
          </Button>
        )}
        <RecordCounter records={recordsCount} totalRecords={totalRecordsCount} />
      </Stack>
      <SearchField debounceTimeMs={300} onSearch={(search) => onFiltersChange({ search: search.toLowerCase() })} />
    </Stack>
  );
};

export default ContactsFilters;
